<div class="notification-snack-bar-container"
     [class.notification-error]="data.type === 'error'"
     [class.notification-success]="data.type === 'success'"
>
  <section>
    <mat-icon class="status-icon" [svgIcon]="data.icon" />
    <span class="message">{{ data.message | translate }}</span>
    <app-general-icon-button buttonIcon="close-thin" buttonStyle="inline" (buttonClicked)="close()"/>
  </section>
</div>
